import React from 'react'
import { PRODUCTS } from '../../products'
import Product from './Product'

const Shop = () => {
  return (
    <div className='shop'>
        <div className='shopTitle'>
            <h1>NikeDas</h1>
        </div>

        {/* mapping the products data whihc we created */}
        <div className='products'>
            {PRODUCTS.map((product)=> <Product data = {product}/>)}
        </div>
    </div>
  )
}

export default Shop
